import React from 'react';
import { Navigate } from 'react-router-dom';
import StorageService from '../services/StorageService';
import AuthHttpService from '../api/AuthHttpService';

function ProtectedRoute({ children }) {
  const auth = StorageService.getAuth();
  const isAdmin = auth?.is_admin || false;

  if (!isAdmin) {
    return <Navigate to="/access-denied" />;
  }

  return children;
}

export default ProtectedRoute;
